
import React, { useState, useContext, useEffect } from "react";
import * as Config from "../constants/Config";
import { useNavigate, Link } from "react-router-dom";

import { contentContext } from "../context/contentContext";
let { lambda, appname } = window.app

const DeleteAccount = () => {
    const { userData } = useContext(contentContext);
    const [image, setImg] = useState('');
    const navigate = useNavigate();
    // const handleBack = () => {
    //     navigate('/')
    // }
    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imagesCDN) {
                    setImg(window.site.common.imagesCDN)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imagesCDN) {
            setImg(window.site.common.imagesCDN)
        }

    }, [window.site]);
    let siteConfig = window?.site?.admin;
    console.log("siteConfig", siteConfig);
    return (
        <>

            <main>
                <div className="error-wrapper">
                    <h1>
                    To request deletion of your account and associated data, Please email us at <a href={`mailto:${siteConfig?.supportEmail}`}>{siteConfig?.supportEmail}</a> or follow the steps below:
                    </h1>
                    <h4>1. Go to My Profile in the app.</h4>
                    <h4>2. Click on the Unsubscribe button.</h4>
                    <h4>3. Once your request is verified, we will permanently delete your account and all related personal data in accordance with our Privacy Policy.</h4>
                    {/* <button className="fill-btn-style mt-3" onClick={handleBack}>BACK TO HOME</button> */}
                </div>
            </main>



        </>
    );
};

export default DeleteAccount;
